import React from 'react';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { NoInternationalShippingIcon } from 'swag-client-common/components/icons/no-international-shipping-icon';
import { NO_INTERATIONAL_SHIPPING_TOOLTIP, NO_INTERATIONAL_SHIPPING_IMG_ALT } from 'swag-client-common/components/partials/header-icons/header-icons-constants';
import { Placement } from 'swag-client-common/constants';
export function NoInternationalShippingTooltip({
  tooltipClasses = {},
  tooltipClassName = '',
  iconClassName = '',
  popperProps = {}
}) {
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: NO_INTERATIONAL_SHIPPING_TOOLTIP,
    placement: Placement.RIGHT,
    mode: "light",
    className: tooltipClassName,
    classes: tooltipClasses,
    interactive: true,
    PopperProps: popperProps
  }, /*#__PURE__*/React.createElement("div", {
    "aria-label": NO_INTERATIONAL_SHIPPING_IMG_ALT,
    className: iconClassName
  }, /*#__PURE__*/React.createElement(NoInternationalShippingIcon, null)));
}